import { Icon, type IconProps } from "@chakra-ui/icon";

function HomeIcon(props: IconProps) {
	return (
		<Icon viewBox="0 0 16 17" {...props} fill="none">
			<path
				opacity="0.12"
				d="M2 7.54337C2 7.16046 2 6.96901 2.04935 6.7927C2.09307 6.63652 2.16491 6.48963 2.26135 6.35924C2.37022 6.21204 2.52135 6.0945 2.82359 5.85942L7.34513 2.34267C7.57935 2.1605 7.69646 2.06941 7.82577 2.0344C7.93987 2.00351 8.06013 2.00351 8.17423 2.0344C8.30354 2.06941 8.42065 2.1605 8.65487 2.34267L13.1764 5.85942C13.4787 6.0945 13.6298 6.21204 13.7386 6.35924C13.8351 6.48963 13.9069 6.63652 13.9506 6.7927C14 6.96901 14 7.16046 14 7.54337V12.3667C14 13.1134 14 13.4868 13.8547 13.772C13.7268 14.0229 13.5229 14.2268 13.272 14.3547C12.9868 14.5 12.6134 14.5 11.8667 14.5H4.13333C3.3866 14.5 3.01323 14.5 2.72801 14.3547C2.47713 14.2268 2.27316 14.0229 2.14532 13.772C2 13.4868 2 13.1134 2 12.3667V7.54337Z"
				fill="currentColor"
			/>
			<path
				d="M5.33333 11.8333H10.6667M7.34513 2.34268L2.82359 5.85943C2.52135 6.09451 2.37022 6.21205 2.26135 6.35925C2.16491 6.48964 2.09307 6.63654 2.04935 6.79272C2 6.96903 2 7.16048 2 7.54338V12.3667C2 13.1134 2 13.4868 2.14532 13.772C2.27316 14.0229 2.47713 14.2268 2.72801 14.3547C3.01323 14.5 3.3866 14.5 4.13333 14.5H11.8667C12.6134 14.5 12.9868 14.5 13.272 14.3547C13.5229 14.2268 13.7268 14.0229 13.8547 13.772C14 13.4868 14 13.1134 14 12.3667V7.54338C14 7.16048 14 6.96903 13.9506 6.79272C13.9069 6.63654 13.8351 6.48964 13.7386 6.35925C13.6298 6.21205 13.4787 6.09451 13.1764 5.85943L8.65487 2.34268C8.42065 2.16051 8.30354 2.06943 8.17423 2.03442C8.06013 2.00352 7.93987 2.00352 7.82577 2.03442C7.69646 2.06943 7.57935 2.16051 7.34513 2.34268Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default HomeIcon;
